import Model, { attr, belongsTo } from "@ember-data/model";
import type HealthCentre from "parog-web/models/health-centre";
import type Medic from "parog-web/models/medic";
import type Patient from "parog-web/models/patient";

export type HealthCentreRole = "support" | "configurator";

export default class HealthCentreCohort extends Model {
  // Inverse relationship is null to avoid mergeDeep errors when updating the healthCentre of a cohort
  // an issue "Cannot remove a resource that is not present" was raised because an update on the inverse
  // relationship was triggered
  @belongsTo("health-centre", {
    async: false,
    inverse: null
  })
  declare healthCentre: HealthCentre;
  @attr("string") declare ippNumber: string | undefined;
  @belongsTo("patient", {
    async: false,
    inverse: "healthCentreCohorts"
  })
  declare patient: Patient;
  @belongsTo("medic", {
    async: false,
    inverse: null
  })
  declare referentMedic: Medic;
  @attr("string") declare role: HealthCentreRole;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "health-centre-cohort": HealthCentreCohort;
  }
}
